export default "__VITE_ASSET__CWvXqYHt__"